import { Activity, ChevronRight } from 'lucide-react'
import { useQuery } from '@tanstack/react-query'
import { listRecentEarthquakes } from '../../../api/earthquakes'
import { QueryBoundary } from '../../../components/common/QueryBoundary'
import { LevelBadge } from '../../../components/common/Status'
import { ScrollArea } from '../../../components/ui/scroll-area'
import { Skeleton } from '../../../components/ui/skeleton'
import { formatMag, formatCoord } from '../../../lib/format'
import { useUiStore } from '../../../stores/ui'
import { cn } from '../../../lib/utils'

export function RecentQuakeList() {
  const query = useQuery({
    queryKey: ['earthquakes', 'recent', 20],
    queryFn: () => listRecentEarthquakes(20),
    refetchInterval: 30_000,
    retry: 1,
  })
  const selectedEventId = useUiStore((s) => s.selectedEventId)

  return (
    <div className="panel-glass flex min-h-0 flex-1 flex-col rounded-xl">
      <div className="flex items-center justify-between border-b border-border px-4 py-3">
        <h2 className="text-sm font-semibold text-foreground">最近地震事件</h2>
        <span className="text-[10px] text-muted-foreground">按时间排序 · 30s 刷新</span>
      </div>
      <QueryBoundary
        query={query}
        skeleton={
          <div className="space-y-2 p-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="h-12 rounded-lg" />
            ))}
          </div>
        }
        isEmpty={(items) => items.length === 0}
        empty={{ title: '暂无地震事件', description: '系统确认地震事件后将在此展示' }}
        className="flex min-h-0 flex-1 flex-col"
      >
        {(items) => (
          <ScrollArea className="min-h-0 flex-1">
            <div className="divide-y divide-border">
              {items.map((quake) => (
                <button
                  key={quake.eventId}
                  onClick={() => useUiStore.getState().selectEvent(quake.eventId)}
                  className={cn(
                    'flex w-full items-center gap-3 px-4 py-2.5 text-left transition',
                    selectedEventId === quake.eventId ? 'bg-primary/[.08]' : 'hover:bg-foreground/[.03]',
                  )}
                >
                  <span className="w-14 shrink-0 font-mono text-sm font-semibold text-critical">
                    {formatMag(quake.magnitude)}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-xs text-foreground">{quake.epicenterName || quake.eventId}</span>
                    <span className="mt-0.5 block truncate font-mono text-[10px] text-muted-foreground">
                      {formatCoord(quake.epicenterLat, quake.epicenterLon)} · {quake.confirmedDevices}/{quake.triggerCount} 触发
                    </span>
                  </span>
                  <LevelBadge alertLevel={quake.alertLevel} pulse={quake.status === 'pending'} />
                  <ChevronRight size={13} className="shrink-0 text-muted-foreground/40" />
                </button>
              ))}
            </div>
          </ScrollArea>
        )}
      </QueryBoundary>
      <div className="border-t border-border px-4 py-2">
        <button
          onClick={() => useUiStore.getState().selectEvent(undefined)}
          className="flex w-full items-center justify-center gap-1 text-[11px] text-primary hover:underline"
        >
          <Activity size={12} /> 点击事件查看详情
        </button>
      </div>
    </div>
  )
}
